module.exports = __webpack_public_path__ + "static/media/investigation-discovery.9ba87b7c.png";